import { createSelector } from '@reduxjs/toolkit';
import { findIndex, isEmpty, isNil } from 'lodash';
import { AppState } from 'src/store';
import { parseFloorsetDropdownData } from '../ConfigurableGrid/utils/ConfigurableGrid.utils';
import {
  SelectorSubheaderDropdownProps,
  getFloorsetData,
  getSelectedFloorset,
  getAttributeBlacklist,
  getCurrentDepartment,
} from '../ConfigurableGrid/ConfigurableGrid.selectors';
import { SubheaderDropdowns } from 'configuration-schemas/viewdefns/viewdefn';
import { blacklistByDataIndex } from 'src/utils/Component/AttributeBlacklist.utils';
import type { GroupBySlice } from './Subheader.slice';

export function getConfigureSelections(state: AppState) {
  return state.subheader.configureSelections;
}

export const getTopMemberConfig = (_state: AppState, { topMember }: SubheaderDropdowns) => {
  return topMember;
};

export const getTopMemberDropdownProps = createSelector(
  getFloorsetData,
  getSelectedFloorset,
  getTopMemberConfig,
  (floorsets, selectedFloorset, topMemberConfig) => {
    if (isEmpty(floorsets)) {
      return;
    }

    const options = parseFloorsetDropdownData(floorsets);
    const selection = isNil(selectedFloorset) ? 0 : findIndex(options, (option) => option.id === selectedFloorset);
    const label = topMemberConfig?.label || 'Floorset';
    const floorsetDropdownProps: SelectorSubheaderDropdownProps = {
      label,
      defaultSelection: 0,
      selection,
      options,
    };

    return floorsetDropdownProps;
  },
);

const getRawGroupBy = (state: AppState): GroupBySlice => state.subheader.groupBy;

export const getGroupBy = createSelector(
  getRawGroupBy,
  getAttributeBlacklist,
  getCurrentDepartment,
  (groupBy, blacklist, currentDepartment): GroupBySlice => {
    if (!blacklist || !currentDepartment) return groupBy;
    return {
      ...groupBy,
      options: blacklistByDataIndex(groupBy.options, blacklist, currentDepartment),
    };
  },
);
